/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Model, { attr } from '@ember-data/model';
import { fragmentArray } from 'ember-data-model-fragments/attributes';

export default Model.extend({
  appId: attr('string'),
  title: attr('string'),
  description: attr('string'),
  assigneeId: attr('string'),
  deflectionText: attr('string'),
  deflectionCta: attr('string'),
  deflectionLink: attr('string'),
  deflectionEnabled: attr('boolean'),
  introButtonText: attr('string'),
  qualificationAttributes: fragmentArray('qualification/attribute'),
});
